import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WA_URL = 'https://wa.me/919246887272?text=Hi%2C%20I%20am%20interested%20in%20an%20admission%20enquiry%20at%20Sri%20Aurobindo%20Montessori%20School';

export default function WhatsAppButton() {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-50 hidden lg:flex flex-col items-end gap-2" data-testid="whatsapp-float-container">
      {showTooltip && (
        <div className="bg-white rounded-2xl shadow-xl border border-blue-100 p-4 max-w-xs fade-in">
          <div className="flex items-start justify-between gap-3">
            <div>
              <p className="font-bold text-[#1E3A8A] text-sm mb-1" style={{ fontFamily: 'Nunito, sans-serif' }}>Chat with us!</p>
              <p className="text-slate-600 text-xs leading-relaxed">Hello! Interested in admissions? We are happy to help. School hours: 9:30 am – 3:30 pm</p>
            </div>
            <button
              onClick={() => setShowTooltip(false)}
              className="text-slate-400 hover:text-slate-600 flex-shrink-0"
              aria-label="Close"
            >
              <X size={14} />
            </button>
          </div>
          <a
            href={WA_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="whatsapp-chat-link"
            className="mt-3 flex items-center justify-center gap-2 w-full bg-[#25D366] text-white rounded-full py-2 text-xs font-bold hover:bg-[#128C7E] transition-colors"
          >
            <MessageCircle size={14} /> Start Chat
          </a>
        </div>
      )}

      <button
        onClick={() => setShowTooltip(!showTooltip)}
        data-testid="whatsapp-float-btn"
        aria-label="WhatsApp"
        className="h-14 w-14 rounded-full bg-[#25D366] text-white shadow-[0_4px_20px_rgba(37,211,102,0.5)] flex items-center justify-center hover:bg-[#128C7E] hover:scale-110 transition-all duration-200"
      >
        <MessageCircle size={26} />
      </button>
    </div>
  );
}
